import { render, staticRenderFns } from "./SubmissionStatistics.vue?vue&type=template&id=0daba649&scoped=true"
import script from "./SubmissionStatistics.vue?vue&type=script&lang=js"
export * from "./SubmissionStatistics.vue?vue&type=script&lang=js"
import style0 from "./SubmissionStatistics.vue?vue&type=style&index=0&id=0daba649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daba649",
  null
  
)

export default component.exports